import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { N } from './number';

const T = ({ as = 'body2', append, className, sx, label, fontSize, children, subTitle, ...props }) => {
  const { t } = useTranslation();
  let translatedChildren = typeof children === 'string' ? t(children) : children;
  if (props && translatedChildren) {
    let words = translatedChildren.split(' ');

    words.forEach((word) => {
      if (word.includes('@')) {
        try {
          translatedChildren = translatedChildren.split(word).join(props[word.replace('@', '')]);
        } catch {}
      }
    });
  }

  return (
    <>
      <Typography
        fontSize={fontSize}
        color={props.color}
        className={className}
        variant={as}
        component={'span'}
        sx={sx}
        {...props}
      >
        <Stack flex flexDirection="column">
          <Stack flex flexDirection="row" gap={1} alignItems="center">
            {label && (
              <Typography>
                <N>{label}</N>
              </Typography>
            )}
            {translatedChildren}
          </Stack>
          {subTitle && (
            <Box>
              <Typography fontSize={12}>{subTitle}</Typography>
            </Box>
          )}
        </Stack>
      </Typography>
      {append && <span>{append}</span>}
    </>
  );
};

export default T;
